import { Component, AfterViewInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GlobalMessageService, GlobalMessageType, RoutingService } from '@spartacus/core';
import {
  LoginFormComponent,
  LoginFormComponentService
} from '@spartacus/user/account/components';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
})

export class CustomLoginFormComponent extends LoginFormComponent implements AfterViewInit{
  constructor(
    protected service: LoginFormComponentService,
    protected routingService: RoutingService,
    private globalMessageService: GlobalMessageService,
    public router: Router
  ) {
    super(service);
  }
  ngAfterViewInit(): void {
    document.getElementsByClassName('header-theme')[0].setAttribute('style', "display: none");
    //const el = document.querySelector("main");
    //console.log(el);
    //el?.setAttribute('style',"padding: 114px");
    //document.getElementsByClassName('LoginPageTemplate')[0].setAttribute('style',"padding: 98px");
  }

  form: FormGroup = this.service.form;
  isUpdating$: Observable<boolean> = this.service.isUpdating$;

  ngOnInit(): void {
    console.log('eee', this.form.controls["userId"]);
    this.form.controls["userId"].clearValidators();
    this.form.controls["userId"].setValidators([Validators.required]);
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_INFO);
  }
  onSubmit(): void {
    this.service.login();
    
    this.routingService.go({
      cxRoute: 'home'
    });
    
  }

}
